module.exports = __webpack_public_path__ + "assets/img/custom-paperwallet/paperwalletemptyFgPurple.b518a3ca1ef915d9eab4b6a40deee6ae.svg";